// src/entry.ts
//
// The application's entry point, and deliberately the only thing a master's
// entry page names.
//
// It has exactly one job and one rule: **no static imports**. That is not a
// style preference, it is the whole mechanism.
//
// A master's entry page is published by its theme, and a release must never
// rewrite it (spec AC-16, ADR-0003). Whatever this module imports STATICALLY,
// the bundler writes into that page — as `<link rel="modulepreload">` hints
// when module preloading is on, and as a chain of `<script src>` tags when it is
// off. Either way the page ends up naming eight or nine content-hashed chunk
// filenames, and every release changes them.
//
// A single dynamic import moves that whole graph behind the entry: the page
// names `assets/entry.js` and nothing else, the bundler's own runtime discovers
// and preloads the rest, and the page stops belonging to a release.
//
// The cost is one round trip: the chunks are found once this file has parsed
// rather than while the page is being read. `assertReleaseIndependent` in the
// build fails if a static import ever creeps back in and undoes this.
import("./main");
